<template>
  <section
    v-if="hasAttachments"
    class="content__attachments content__narrow"
  >
    <section-title v-t="'p.contentPage.title.documents'"/>
    <div class="content__attachments-list">
      <a
        v-for="attachment in content.attachments"
        :href="attachment.url"
        :key="attachment.id"
        class="content__attachment"
        target="_blank"
        @click="handleAttachment(attachment, $event)"
      >
        <font-awesome-icon
          :icon="attachmentIcon(attachment)"
          size="2x"
        />
        <div class="content__attachment-text">
          <div class="content__attachment-name">
            {{ attachment.name }}
          </div>
          <div class="content__attachment-size">
            {{ attachmentFileSize(attachment) }}
          </div>
        </div>
      </a>
    </div>

    <vue-gallery
      :images="articleImages"
      :index="galleryIndex"
      @close="galleryIndex = null"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import isBlank from 'is-blank'
import filesize from 'filesize'
import VueGallery from 'vue-gallery'
import PageMixin from '@/mixins/pages/Page'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  mixins: [PageMixin],
  components: {
    VueGallery,
    FontAwesomeIcon
  },
  data () {
    return {
      galleryIndex: null
    }
  },
  computed: {
    ...mapState({
      content: state => state.content.content,
    }),
    imageAttachments () {
      if (this.content && !isBlank(this.content.attachments)) {
        return this.content.attachments.filter(d => d.contentType.startsWith('image/'))
      }
    },
    articleImages () {
      return this.imageAttachments && this.imageAttachments.map(d => d.url)
    },
    hasAttachments () {
      return this.content && !isBlank(this.content.attachments)
    },
    attachmentIcon () {
      return attachment => {
        return attachment.contentType.startsWith('image/')
          ? 'file-image'
          : 'file'
      }
    },
    attachmentFileSize () {
      return attachment => {
        return filesize(attachment.fileSize)
      }
    }
  },
  methods: {
    handleAttachment (attachment, event) {
      const index = this.articleImages.indexOf(attachment.url)

      // return if attachment is no image
      if (index < 0) { return }

      event.preventDefault()
      this.galleryIndex = index
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.content__attachment
  align-items: center
  background-color: var(--contentAttachmentBackground)
  border-radius: 3px
  color: #fff
  cursor: pointer
  display: flex
  font-size: 14px
  height: 80px
  justify-content: flex-start
  margin-bottom: 10px
  padding: 0 31px
  text-decoration: none !important

  .svg-inline--fa
    font-size: 32px

  &:hover,
    background-color: var(--contentAttachmentBackgroundHover)

.content__attachment-text
  margin-top: 3px
  padding-left: 29px
  max-width: 100%

.content__attachment-name
  +ellipsis
  font-size: 14px
  font-weight: 700
  line-height: 1.2
  padding-right: 20px

.content__attachment-size
  font-size: 12px
  padding-left: 2px
</style>




// WEBPACK FOOTER //
// src/components/contents/content/ContentAttachments.vue